import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { Settings } from "../../../styles/theme"

const AdvertisementStyled = styled.div`
  position: relative;
  > div {
    display: inline-block;
    width: 100%;
    .wrap {
      width: 100%;
      position: relative;
      overflow: hidden;
      min-height: 120px;
      height: ${props => (props.height ? props.height : "10vh")};
      @media screen and (max-width: ${Settings.sizeM}) {
        display: none;
      }
      > div {
        position: absolute;
        width: 100%;
        transition: all 275ms ease-in-out;
      }
    }
    .wrapMobile {
      display: none;
      min-height: ${props =>
        props.mobileHeight ? props.mobileHeight : "none"};
      height: ${props => (props.mobileHeight ? props.mobileHeight : "10vh")};
      @media screen and (max-width: ${Settings.sizeM}) {
        display: block;
      }
    }
  }
`

export class Advertisement extends React.Component {
  constructor(props) {
    super(props)
    const max = props.advertisements.length - 1
    console.log(max)
    this.state = {
      selected: 0,
      max: max,
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => this.cycle(), 5000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  cycle = () => {
    const max = this.state.max
    const selected = this.state.selected
    max > selected
      ? this.setState({ selected: selected + 1 })
      : this.setState({ selected: 0 })
  }

  render() {
    return (
      <AdvertisementStyled
        height={this.props.height}
        mobileHeight={this.props.mobileHeight}
        mobileNoPadding={this.props.mobileNoPadding}
      >
        <div>
          <div className="wrap">
            {this.props.advertisements.map((ad, i) => (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  transform:
                    "translateX(" + (i - this.state.selected) * 100 + "%)",
                }}
                onClick={
                  typeof window !== "undefined"
                    ? () => {
                        window.open(ad.slug)
                      }
                    : () => {
                        ""
                      }
                }
              >
                <Img fluid={ad.image.fluid} />
              </div>
            ))}
          </div>
          <div className="wrap wrapMobile">
            {this.props.advertisementMobile.map((ad, i) => (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  transform:
                    "translateX(" + (i - this.state.selected) * 100 + "%)",
                }}
                onClick={
                  typeof window !== "undefined"
                    ? () => {
                        window.open(ad.slug)
                      }
                    : () => {
                        ""
                      }
                }
              >
                <Img fluid={ad.image.fluid} />
              </div>
            ))}
          </div>
        </div>
      </AdvertisementStyled>
    )
  }
}
